import script from "./DrawerMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawerMenu.vue?vue&type=script&setup=true&lang=js"

import "./DrawerMenu.vue?vue&type=style&index=0&id=67fe7a5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67fe7a5e"]])

export default __exports__